import { create } from 'zustand'
import { supabase } from '@unvld/db'
import type { Staff, Organization } from '@unvld/db'

interface AuthState {
  user: any | null
  staff: Staff | null
  org: Organization | null
  loading: boolean
  error: string | null

  init: () => Promise<void>
  login: (email: string) => Promise<{ success: boolean; error?: string }>
  logout: () => Promise<void>
}

export const useAuth = create<AuthState>((set, get) => ({
  user: null,
  staff: null,
  org: null,
  loading: true,
  error: null,

  init: async () => {
    try {
      const { data: { session } } = await supabase.auth.getSession()
      if (!session?.user) {
        set({ loading: false })
        return
      }

      // Get staff record (includes org via RLS)
      const { data: staff } = await supabase
        .from('staff')
        .select('*')
        .eq('user_id', session.user.id)
        .eq('active', true)
        .single()

      if (!staff) {
        set({ user: session.user, loading: false, error: 'Kein Club-Zugang gefunden' })
        return
      }

      // Get organization
      const { data: org } = await supabase
        .from('organizations')
        .select('*')
        .eq('id', staff.org_id)
        .single()

      // Update last active
      await supabase
        .from('staff')
        .update({ last_active_at: new Date().toISOString() })
        .eq('id', staff.id)

      set({ user: session.user, staff, org, loading: false })
    } catch (err) {
      console.error('Auth init error:', err)
      set({ loading: false, error: 'Anmeldefehler' })
    }
  },

  login: async (email: string) => {
    const { error } = await supabase.auth.signInWithOtp({
      email,
      options: {
        emailRedirectTo: `${window.location.origin}/auth/callback`,
      },
    })

    if (error) return { success: false, error: error.message }
    return { success: true }
  },

  logout: async () => {
    await supabase.auth.signOut()
    set({ user: null, staff: null, org: null })
  },
}))
